import * as React from 'react'
import { withStatus } from '../status'
import { replace } from 'react-router-redux'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import fieldsActions from './fields-actions'

/*

Handles the state of the form fields. The fields actions are also available on the
global context. ie:

window.updateField
window.updateFields
window.clearFields

This is convenient for developer tools such as Chrome snippets

*/


function mapStateToProps(state, intialProps){
    return {
        ...intialProps,
        fields: state.fields
    }
}


function mapDispatchToProps(dispatch, props){
    return {
        actions:{
            ...props.actions,
            fields: bindActionCreators(fieldsActions, dispatch)
        }
    }
}


export function withFields(Wrapped){

    return connect( mapStateToProps, mapDispatchToProps)(class extends React.Component<any, any>{
    
        render(){
            return <Wrapped { ...this.props } />
        }
    
    })

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/fields/index.tsx